<template>
  <div class="row">
    <div class="top-bar">
      <div class="top-bar-left"><p>Events ({{ totalCount }} items)</p></div>
      <burger />
      <div class="top-bar-right">
        <div class="top-bar-filters events-top-bar-filters">
          <a href="#" class="top-bar-reset-btn" @click.prevent="resetFilters()"> Reset filters </a>
          <div class="top-bar-filter ev-search-filter">
            <search-filter :initial="filters.query" @search="setFilter('query', $event)" />
          </div>
          <div class="top-bar-filter ev-second-top-filter ev-user-filter">
            <user-search-filter :initial="filters.user_id" @chosen="setFilter('user_id', $event.id)"/>
          </div>
          <div class="top-bar-filter top-bar-filter-third">
            <p class="label">Filter:</p>
            <location-filter :location="filters.location_id" @location="setFilter('location_id', $event)" />
            <type-filter :type="filters.category" @type="setFilter('category', $event)" />
          </div>
          <div class="top-bar-filter top-bar-filter-calendar">
            <date-filter :date="filters.date" @selectDay="filters.date = $event, updateDateFilter($event)"/>
          </div>
          <div class="top-bar-filter top-bar-filter-time">
            <time-filter :start="filters.time_start" :end="filters.time_end" @selectTime="setTime($event)"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container-main">
      <div class="container-fluid right-container" data-simplebar id="items-container">
        <v-infinite-scroll :loading="$store.state.loading" @bottom="loadMore" :offset='20' style="max-height: 90vh; overflow-y: scroll;">
          <table class="table items-table">
            <tbody>
              <!-- ITEM -->
              <tr class="item" v-for="(event, index) in events" :key="event.id">
                <td class="avatar" @click="redirect('alert', event.id)">
                  <div class="cam-label-container">
                    <p>CAM {{ event.camera_id }}</p>
                  </div>
                  <img :src="event.image_crop_path" v-if="event.category == 2" class="identified-border" alt="">
                  <img :src="event.image_crop_path" v-else class="unidentified-border" alt="">
                </td>
                <td class="col-id" @click="redirect('alert', event.id)">
                  <p>Event ID</p>
                  <p>{{ event.id }}</p>
                </td>
                <td @click="redirect('alert', event.id)">
                  <p>Time start</p>
                  <p>{{ moment(event.time_start).format('MMM  DD h:mm A') }}</p>
                </td>
                <td @click="redirect('alert', event.id)">
                  <p>Time end</p>
                  <p>{{ moment(event.time_end).format('MMM DD h:mm A') }}</p>
                </td>
                <td @click="redirect('alert', event.id)">
                  <p>Location</p>
                  <p>{{ event.camera ? event.camera.location.name : '' }}</p>
                </td>
                <td class="col-note" @click="redirect('alert', event.id)">
                  <p>Note</p>
                  <p>{{ event.notes }}</p>
                </td>
                <td class="al-col-type ev-col-type" @click="redirect(`events?user_id=${event.user.id}`)">
                  <div class="row item-user-img">
                    <div class="ev-identified-user-photo" v-if="event.category == 2">
                      <user-photo :user="event.user" cssClass="identified-border h60" />
                    </div>
                    <div class="ev-identified-user-photo" v-else>
                      <user-photo :user="event.user" cssClass="unidentified-border h60" />
                    </div>
                    <div class="col-7" v-if="event.category == 2">
                      <div class="identified-status-circle ev-status-circle"></div><br>
                      <p class='identified-status ev-unident-status'>
                        <span class="user-link" v-if="event.user">
                          {{ event.user.first_name }} {{ event.user.last_name }} [{{ event.user.id }}]
                        </span>
                      </p>
                    </div>
                    <div class="col-7" v-else>
                      <div class="unidentified-status-circle ev-status-circle"></div><br>
                      <p class='unidentified-status ev-unident-status user-link'>
                        {{ event.user.first_name }} {{ event.user.last_name }} [{{ event.user.id }}]
                      </p>
                    </div>
                  </div>
                </td>
                <td class="col-flag ev-col-flag text-center">
                  <a href="#" @click="flagEvent(index)">
                    <span class="flag-icon" data-toggle="tooltip" data-placement="bottom" title="Flag"></span>
                    <!-- <span class="al-large-item-actions">&nbsp;Flag</span> -->
                  </a>
                </td>
                <td class="col-identify ev-col-identify text-center">
                  <a href="#identifyModal" data-toggle="modal" data-target="#identifyModal" @click="item = event">
                    <span class="identify-icon" data-toggle="tooltip" data-placement="bottom" title="Identify person"></span>
                    <!-- <span class="al-large-item-actions">&nbsp;Identify person</span> -->
                  </a>
                </td>
                <td class="col-identify text-center">
                  <a href="#" @click="sendNotification(index)">
                    <span class="notification-icon" data-toggle="tooltip" data-placement="bottom" title="Send notification"></span>
                    <!-- <span class="al-large-item-actions">&nbsp;Send notification</span> -->
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </v-infinite-scroll>
      </div>
    </div>
    <div class="events-identify-container">
      <identify-modal :item="item" @identified="identified($event)" @create="edit = true" v-if="item"/>
    </div>
    <user-profile :user="item.user" @close="edit = false" @saved="userIdentified()" v-if="edit"/>
  </div>
</template>

<script>
  import IdentifyModal from '@/components/IdentifyModal';
  import UserSearchFilter from '@/components/filters/UserSearch';
  import SearchFilter from '@/components/filters/Search';
  import LocationFilter from '@/components/filters/Location';
  import TypeFilter from '@/components/filters/Type';
  import DateFilter from '@/components/filters/Date';
  import TimeFilter from '@/components/filters/Time';
  import UserPhoto from '@/components/users/Photo';
  import Burger from '@/components/Burger';
  import UserProfile from '@/views/UserProfile';

  export default {
    name: 'Events',
    components: {
      IdentifyModal,
      UserSearchFilter,
      SearchFilter,
      TypeFilter,
      DateFilter,
      TimeFilter,
      LocationFilter,
      UserPhoto,
      UserProfile,
      Burger
    },
    data() {
      return {
        edit: false,
        load: true,
        events: [],
        totalCount: 0,
        item: {},
        filters: {
          'query': '',
          'user_id': null,
          'location_id': null,
          'category': null,
          'start': 0,
          'limit': 20,
          'date': null,
          'time_start': { HH: '', mm: '' },
          'time_end': { HH: '', mm: '' },
        },
      };
    },
    watch:{
      $route() {
        this.init();
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.initialFilters();

        if (!window._.isEmpty(this.$router.currentRoute.query)) {
          let vm = this;

          window._.forIn(this.$router.currentRoute.query, function (value, index) {
            if (index == 'time_start' || index == 'time_end') {
              let time = value.split(':');

              vm.filters[index] = {HH: time[0], mm: time[1]};
            } else {
              vm.filters[index] = value;

              if (index == 'date') {
                vm.date = new Date(value);
              }
            }
          });
        }

        this.getItems();
      },
      initialFilters() {
        this.filters = {
          'query': '',
          'user_id': null,
          'location_id': null,
          'category': null,
          'start': 0,
          'limit': 20,
          'date': null,
          'time_start': { HH: '', mm: '' },
          'time_end': { HH: '', mm: '' },
        };
      },
      resetFilters() {
        this.filters = {
          'query': '',
          'location_id': null,
          'category': null,
          'start': 0,
          'user_id': this.filters['user_id'],
          'limit': 20,
          'date': null,
          'time_start': { HH: '', mm: '' },
          'time_end': { HH: '', mm: '' },
        };

        if(this.filters.user_id != null) {
          this.filters.user_id = null;
        } else {
          this.getItems();
        }
      },
      getFilters() {
        let data = window._.omit(this.filters, ['time_start', 'time_end', 'date']), filters = [];

        window._.forIn(data, function (value, index) {
          if (value != null) {
            if (index == 'location_id') {
              filters.push(`location_ids=[${value}]`);

              return;
            }

            filters.push(`${index}=${value}`);
          }
        });

        if (this.filters.date || this.filters.time_start.HH) {
          filters.push(`time_start=${this.getDate()} ${this.getTime(this.filters.time_start)}`);
          filters.push(`time_end=${this.getDate()} ${this.getTime(this.filters.time_end, '23:59:59')}`);
        }

        return filters.join('&');
      },
      getItems(ignoreFilters = false) {
        this.load = true;
        this.resetPagination();

        this.axios.get(`/events` + `${!ignoreFilters ? `?${this.getFilters()}` : ''}`)
          .then(response => {
            if (!response.data.events.length) {
              this.load = false;
            }

            this.events = response.data.events;
            this.totalCount = response.data.total_count || 0;
          });
      },
      loadMore() {
        if (!this.load) {
          return;
        }

        this.filters.start += (!this.filters.start ? 20 : 10);
        this.filters.limit = 10;

        this.axios.get(`/events?${this.getFilters()}`)
          .then(response => {
            if (!response.data.events.length) {
              this.load = false;
            }

            for (let i in response.data.events) {
              this.events.push(response.data.events[i]);
            }
            // Update total count if provided
            if (response.data.total_count !== undefined) {
              this.totalCount = response.data.total_count;
            }
          });
      },
      flagEvent(index) {
        if(confirm("Are you sure you want to Flag this event?")) {
          const data = {
            event_id: this.events[index].id,
            fields: ["flagged"],
            values: [1]
          };

          this.$store.dispatch('alert/updateEvent', data)
            .then(() => {
              this.$snotify.success("Event successfully flaged");
              this.events[index].flagged = 1;
              this.events.splice(index, 1);
            });
          }
      },
      sendNotification(index) {
        if(confirm("Are you sure you want to Send notification?")) {
          this.$store.dispatch('alert/sendNotification', {event_id: this.events[index].id})
            .then(() => this.$snotify.success("Notification successfully sent!"));
        }
      },
      identified(state) {
        let eventIndex = this.events.findIndex(x => x.id === state.event.id)

        this.$snotify[state.status](state.message);

        if (state.event !== undefined && eventIndex != -1) {
          this.$set(this.events, eventIndex, state.event);
        }

        console.log(state);
        
        if (state.new) {
          this.item = state.event;
          this.edit = true;
        }
      },
      userIdentified() {
        let data = new FormData();

        data.set('event_id', this.item.id);
        data.set('user_id', this.item.user_id);

        this.axios.post(`/identify`, data).then(() => this.getItems());
        this.edit = false;
      }
    },
  };
</script>

<style scoped>
  td:hover .user-link {
    text-decoration: underline;
  }

  .top-bar-left {
    flex: 0.25;
  }
</style>
